const LEGACY_COUNTRIES = ['US', 'CA'];

export const kojicPerCapsule = (countryCode) => {
  const code = (countryCode || '').toUpperCase();
  return !code || LEGACY_COUNTRIES.includes(code) ? 2.0 : 1.0;
};
